import React from 'react';
import heroImage from '../../assets/hero.webp';
import './HomeHero.css';

const HomeHero: React.FC = () => {
  return (
    <section className="home-hero">
      <div className="home-hero__image-container">
        <img src={heroImage} alt="StyroR – Professionelles Styropor und EPS Recycling in Hamburg" className="home-hero__image" width={2912} height={1632} />
      </div>
      <div className="home-hero__overlay"></div>
      <div className="home-hero__content">
        <h1 className="home-hero__title">
          <span className="home-hero__title-main">StyroR</span>{' '}
          <span className="home-hero__title-sub">Styropor Recycling Hamburg</span>
        </h1>
        <p className="home-hero__description">Ihr Spezialist für professionelles Styropor Recycling, EPS Entsorgung und Isolierung Recycling in Hamburg – umweltgerecht und gewinnbringend</p>
        <p className="home-hero__tagline">Sie retten die Umwelt & verdienen Geld</p>
      </div>
    </section>
  );
};

export default HomeHero;